import { __ } from '@/hub-shared/utils/i18n';
import type { MissionParticipant } from '../../types/missionPortal';
import { missionRoleLabel } from '../../utils/missionRoleLabels';
import MissionUserLink from './MissionUserLink';

type MissionCollaboratorsCardProps = {
  collaborators: MissionParticipant[];
  currentUserId: number;
  portalPath: string;
  onNavigate: (path: string) => void;
};

const KNOWN_ROLE_SUFFIXES = new Set([
  'expert_comptable',
  'collaborateur_comptable',
  'utilisateur_entreprise',
]);

// Maps known WP roles to the table-badge--role-* modifier defined in _tables.scss.
const roleBadgeClass = (role: string): string => {
  const suffix = KNOWN_ROLE_SUFFIXES.has(role) ? role : 'default';
  return `table-badge table-badge--role-${suffix}`;
};

const MissionCollaboratorsCard = ({
  collaborators,
  currentUserId,
  portalPath,
  onNavigate,
}: MissionCollaboratorsCardProps) => (
  <section className="container-style mission-page__card" aria-labelledby="mission-collaborators-heading">
    <h2 id="mission-collaborators-heading" className="h4">{__('Collaborateurs de mission')}</h2>
    {collaborators.length === 0 ? (
      <p className="mission-page__empty">{__('Aucun collaborateur n’a encore contribué à la mission.')}</p>
    ) : (
      <ul className="mission-collaborators__list">
        {collaborators.map((collaborator) => (
          <li className="mission-collaborators__item" key={collaborator.id}>
            <MissionUserLink
              userId={collaborator.id}
              displayName={collaborator.display_name}
              currentUserId={currentUserId}
              portalPath={portalPath}
              onNavigate={onNavigate}
              className="mission-collaborators__name"
            />
            <span className={roleBadgeClass(collaborator.role)}>{missionRoleLabel(collaborator.role)}</span>
          </li>
        ))}
      </ul>
    )}
  </section>
);

export default MissionCollaboratorsCard;
